import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { BusinessSolutionAPI } from "@api";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { HeaderSection, FooterSection, LeafBox, Accordion } from "@components";

import "./DetailBusinessSolution.scss";
import { TitleComponent } from "../../../common/components/TitleComponent";
const Container = styled.div`
  background-color: #ffffff;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const BenefitBox = styled.div`
  font-size: 16px;
  line-height: 150%;
  color: #5e514d;

  ol,
  ul {
    padding-left: 1em;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const setSize = (il, index) => {
  let size = il === 2 || il === 4 ? 6 : 4;
  if (il > 4) {
    const mod = il % 3;
    if (mod === 1 && index === il - 1) {
      size = 12;
    } else if (mod === 2 && (index === il - 1 || index === il - 2)) {
      size = 6;
    }
  }

  return size;
};

const DetailBusinessSolution = function () {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setdata] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [leafBoxView, setLeafBoxView] = useState([]);

  const accordion2Title = (id) => {
    const title = {
      2117: "bank_garansi_dokumen",
      2115: "ketentuan_kredit",
    };

    return typeof title[id] != "undefined" ? title[id] : "informasi_lainnya";
  };

  const leafboxTitle = (id) => {
    const title = {
      2116: "trade_finance_produk",
      2124: "fitur_lain_tersedia",
    };

    return typeof title[id] != "undefined"
      ? title[id]
      : "solusi_tabungan_keunggulan";
  };

  const loadData = async function () {
    setisLoading(true);
    const reportData = await BusinessSolutionAPI(`/${id}`);    
    setdata(reportData.data.data);
    setisLoading(false);
  };

  const generateLeafBoxView = () => {
    if (typeof data.blockDataCard == "undefined") return false;

    let tmp = [];
    data.blockDataCard.map((item, index) => {
      const l = data.blockDataCard.length;
      const size = setSize(l, index);

      tmp.push(
        <LeafBox
          key={index}
          size={size}
          number={index + 1}
          thin={true}
          title={item.titleDataCardSolbis}
          description={item.descriptionDataCardSolbis}
        />
      );
    });

    setLeafBoxView(tmp);
  };

  useEffect(() => {
    generateLeafBoxView();
  }, [data]);

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Container>
      <TitleComponent title={data.title} />
      {!isLoading && (
        <div className="saving-detail">
          <Desktop>
            <HeaderSection
              title={data.title}
              group={t("your_business_solution")}
              description={data.description}
              banner={data.imageBannerDesktop}
              showButton={false}
            />
          </Desktop>
          <Mobile>
            <HeaderSection
              title={data.title}
              group={t("your_business_solution")}
              description={data.description}
              banner={data.imageBannerMobile}
              showButton={false}
            />
          </Mobile>

          <div className="p-0 m-0 container-fluid">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              {id === "2117" &&
                typeof data.blockDataAccordion1 != "undefined" &&
                data.blockDataAccordion1.length > 0 && (
                  <div>
                    <h2 className="mt-5 mb-4 section-title">
                      {data.blockDataAccordion1[0].subTitleAccordion1}
                    </h2>
                    <BenefitBox
                      dangerouslySetInnerHTML={{
                        __html: data.blockDataAccordion1[0].contentAccordion1,
                      }}
                    />
                  </div>
                )}

              {typeof data.blockDataCard != "undefined" &&
                data.blockDataCard.length > 0 && (
                  <div>
                    {["2117"].indexOf(id) < 0 && (
                      <h2 className="mt-5 mb-4 section-title">
                        {t(leafboxTitle(id), { tabungan: data.title })}
                      </h2>
                    )}

                    <div className="row">{leafBoxView}</div>
                  </div>
                )}
              
              {typeof data.blockDataAccordion1 != "undefined" &&
                data.blockDataAccordion1.length > 0 && (
                  <div className="">
                    <h2 className="mt-5 mb-2 section-title">
                      {data.getAccordionTitle1}
                    </h2>
                    {data.blockDataAccordion1.map((item, index) => {
                      if (id === "2117") {
                        if (index === 0) return true;
                        return (
                          <div className="mt-4">                          
                            <Accordion
                              key={index}
                              title={item.subTitleAccordion1}
                            >
                              {item.contentAccordion1}
                            </Accordion>
                          </div>
                        );
                      } else if (id === "2111") {
                        return (
                          <div className="mt-4">
                            <Accordion
                              key={index}
                              title={item.subTitleAccordion1}
                            >
                              {item.contentAccordion1}
                            </Accordion>
                          </div>
                        );
                      } else {
                        return (
                          <div key={index}>                            
                            <div className="mt-4">
                              <Accordion
                                key={index}
                                title={item.subTitleAccordion1}
                              >
                                {item.contentAccordion1}
                              </Accordion>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                )}

              {typeof data.blockDataAccordion2 != "undefined" &&
                data.blockDataAccordion2.length > 0 && (
                  <div className="mb-5">
                    <h2 className="mt-5 mb-4 section-title">
                      {data.getAccordionTitle2}
                    </h2>

                    <div className="row">
                      {data.blockDataAccordion2.map((item, index) => {
                        return (
                          <Accordion
                            key={index}
                            title={item.subTitleAccordion2}
                          >
                            {item.contentAccordion2}
                          </Accordion>
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}

      <FooterSection currentPage={t("solusi_untuk_bisnis_anda")} />
    </Container>
  );
};

export default DetailBusinessSolution;
